const certificate = "-----BEGIN CERTIFICATE-----\n" +
"MIIFDDCCAvSgAwIBAgIQNzkyMDI2MDgyMTE1MjA1MDANBgkqhkiG9w0BAQ0FADCB\n" +
"mDELMAkGA1UEBhMCVVMxCzAJBgNVBAgMAk5ZMRswGQYDVQQKDBJRWiBJbmR1c3Ry\n" +
"aWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcGA1UEAwwQ\n" +
"cXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBxemluZHVz\n" +
"dHJpZXMuY29tMB4XDTI2MDgyMTE1MjA1MFoXDTI3MDgyMTE2MTYzMVowgcUxCzAJ\n" +
"BgNVBAYMAkZSMRIwEAYDVQQIDAlPY2NpdGFuaWUxETAPBgNVBAcMCFRPVUxPVVNF\n" +
"MQ4wDAYDVQQKDAVPYW5kQjEOMAwGA1UECwwFT2FuZEIxDjAMBgNVBAMMBU9hbmRC\n" +
"MSEwHwYJKoZIhvcNAQkBDBJ0ZWNobmlxdWVAb2FuZGIuZXUxPDA6BgNVBA0MM3Jl\n" +
"bmV3YWwtb2YtNDIzMGQ3OGY2MDYyNGFhODAxMjU4MTY5ODAxMGI4NzkxMDQ3YjUy\n" +
"YTCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBAJnmmNoU7X+ijoJkTTx0\n" +
"NcDZeDUX01lLfdO6zMB+LQObUqX8h7LCUclBa+caML0LCWovb4f2V0ghxJu8G3HB\n" +
"kPuyzv1UL8uYaAbCC4GqtptDJFYMJtSlpGTOLBOrm470al5bLCfmyXxc2wUAB13o\n" +
"Y+jLhX3d8Xakc583RL/ZOn4vt+WyTcx5cW3lHViXK4/dWUR4Z8xTR+6EAN98pXJL\n" +
"UTV2UtIgfdIj+KU6sKEDJUA6ZjW/JXyqr/LUv3JP/Tto/ejUXCGRDaFacsHPNAGc\n" +
"XWAgTLlGJkdq3KW8CZlb6itfo8cDL/7IJ+OPwaoSKC3m50ETU851+R+DjRbKDd/G\n" +
"YOUCAwEAAaMjMCEwHwYDVR0jBBgwFoAUkKZQt4TUuepf8gWEE3hF6Kl1VFwwDQYJ\n" +
"KoZIhvcNAQENBQADggIBABK90Igt8IP/8NLr4lhvfyMFdesHodr2i9dPDEh7jL6J\n" +
"MB5Y22+QDaPeRa//FeFNbh6vLiy0BkQ85uh/vdXn0KIrH3dyO43aI9L59NEfWEDw\n" +
"dFHF9vupGZxuNFC0xnYporAbDfpwzJVlDbL5OgrVTmzHTsKdmsefHcnHMQVz76bM\n" +
"nmUpI3vFEOdPfhpIk4IMw7emLmqQwHGF4t1RDf8eJETPOZlqwekTbStevBaBouN5\n" +
"f0YB98N9K47MsiYr30wdAiGoBnz/RDDB38ETu37YkPTInfiRchDtVUIF78sL7KXt\n" +
"J+i+PAzf0fgzdaeeK5iNet0tbm0hoj9hYMoTW5PpDHJerIoYe0MgP2FsBgQe4WXL\n" +
"rJ/5lhAA9DeYThUeGIWRvGTYErkqGkZ55wXX2eFdDCqYASUI//WZH8wgsQGfvuXt\n" +
"8Rs6DpG/4sgii07VUkOqpaZm9dAD12cs7ZOTOE8w1gepLRXCqrAPQaPY0Ca6r3qd\n" +
"OIlxWFZZRZpCRZmlRjSgchb+/R3DJeHhNAzGhix6jEhW9c0qWo/+5rEpL9e/XT1i\n" +
"qp1Nc8g5rnFj5lUiX1PFtWWqNXvAfT4Qeh1035ct1fdoQd8m9Cml51IGNJJbEMdQ\n" +
"wfsmMPNcTPdmacWqc/JDXzOIAdSiVNnBBri1GxM311qZCndv+EKaP+3a1F0tmHev\n" +
"-----END CERTIFICATE-----\n" +
"--START INTERMEDIATE CERT--\n" +
"-----BEGIN CERTIFICATE-----\n" +
"MIIFEjCCA/qgAwIBAgICEAAwDQYJKoZIhvcNAQELBQAwgawxCzAJBgNVBAYTAlVT\n" +
"MQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYDVQQKDBJRWiBJ\n" +
"bmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcG\n" +
"A1UEAwwQcXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBx\n" +
"emluZHVzdHJpZXMuY29tMB4XDTE1MDMwMjAwNTAxOFoXDTM1MDMwMjAwNTAxOFow\n" +
"gZgxCzAJBgNVBAYTAlVTMQswCQYDVQQIDAJOWTEbMBkGA1UECgwSUVogSW5kdXN0\n" +
"cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMxGTAXBgNVBAMM\n" +
"EHF6aW5kdXN0cmllcy5jb20xJzAlBgkqhkiG9w0BCQEWGHN1cHBvcnRAcXppbmR1\n" +
"c3RyaWVzLmNvbTCCAiIwDQYJKoZIhvcNAQEBBQADggIPADCCAgoCggIBANTDgNLU\n" +
"iohl/rQoZ2bTMHVEk1mA020LYhgfWjO0+GsLlbg5SvWVFWkv4ZgffuVRXLHrwz1H\n" +
"YpMyo+Zh8ksJF9ssJWCwQGO5ciM6dmoryyB0VZHGY1blewdMuxieXP7Kr6XD3GRM\n" +
"GAhEwTxjUzI3ksuRunX4IcnRXKYkg5pjs4nLEhXtIZWDLiXPUsyUAEq1U1qdL1AH\n" +
"EtdK/L3zLATnhPB6ZiM+HzNG4aAPynSA38fpeeZ4R0tINMpFThwNgGUsxYKsP9kh\n" +
"0gxGl8YHL6ZzC7BC8FXIB/0Wteng0+XLAVto56Pyxt7BdxtNVuVNNXgkCi9tMqVX\n" +
"xOk3oIvODDt0UoQUZ/umUuoMuOLekYUpZVk4utCqXXlB4mVfS5/zWB6nVxFX8Io1\n" +
"9FOiDLTwZVtBmzmeikzb6o1QLp9F2TAvlf8+DIGDOo0DpPQUtOUyLPCh5hBaDGFE\n" +
"ZhE56qPCBiQIc4T2klWX/80C5NZnd/tJNxjyUyk7bjdDzhzT10CGRAsqxAnsjvMD\n" +
"2KcMf3oXN4PNgyfpbfq2ipxJ1u777Gpbzyf0xoKwH9FYigmqfRH2N2pEdiYawKrX\n" +
"6pyXzGM4cvQ5X1Yxf2x/+xdTLdVaLnZgwrdqwFYmDejGAldXlYDl3jbBHVM1v+uY\n" +
"5ItGTjk+3vLrxmvGy5XFVG+8fF/xaVfo5TW5AgMBAAGjUDBOMB0GA1UdDgQWBBSQ\n" +
"plC3hNS56l/yBYQTeEXoqXVUXDAfBgNVHSMEGDAWgBQDRcZNwPqOqQvagw9BpW0S\n" +
"BkOpXjAMBgNVHRMEBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQAJIO8SiNr9jpLQ\n" +
"eUsFUmbueoxyI5L+P5eV92ceVOJ2tAlBA13vzF1NWlpSlrMmQcVUE/K4D01qtr0k\n" +
"gDs6LUHvj2XXLpyEogitbBgipkQpwCTJVfC9bWYBwEotC7Y8mVjjEV7uXAT71GKT\n" +
"x8XlB9maf+BTZGgyoulA5pTYJ++7s/xX9gzSWCa+eXGcjguBtYYXaAjjAqFGRAvu\n" +
"pz1yrDWcA6H94HeErJKUXBakS0Jm/V33JDuVXY+aZ8EQi2kV82aZbNdXll/R6iGw\n" +
"2ur4rDErnHsiphBgZB71C5FD4cdfSONTsYxmPmyUb5T+KLUouxZ9B0Wh28ucc1Lp\n" +
"rbO7BnjW\n" +
"-----END CERTIFICATE-----"

export default certificate
